<div class="main-container">
    <div class="mdl-container">
        <div class="d-grid mdl-header">
            <div class="center-svg">
                <img [src]="'assets/svg/' + 
                    (data.action === 'delete' ? 'delete-icon' : 
                     data.action === 'activate' ? 'action-check' : 'close-icon') + '.svg'" 
                    alt="">
            </div>
            <div>
                <h4 class="text-semibold">
                    {{data.action === 'delete' ? 'Eliminar' : 
                      data.action === 'activate' ? 'Activar' : 'Desactivar'}} 
                    {{data.mode == 'multiple-users' ? 'usuarios' : 'usuario'}}
                </h4>
            </div>
            <div>
                <h3 class="color-gray text-semibold">
                    <div class="center-svg">
                        <img (click)="closeMdl();" class="close-button" src="assets/svg/close-icon.svg" alt="">
                    </div>
                </h3>
            </div>
        </div>
        <div class="mdl-body mt-5">
            <div class="text-center text-light">
                <!-- Para un solo usuario -->
                <h5 *ngIf="data.mode !== 'multiple-users'">
                    ¿Estás seguro que quieres 
                    {{data.action === 'delete' ? 'eliminar a' : 
                      data.action === 'activate' ? 'activar a' : 'desactivar a'}} 
                    <span class="text-semibold">{{data.nombre}} {{data.apellido}}</span>?
                </h5>
                
                <!-- Para múltiples usuarios -->
                <h5 *ngIf="data.mode === 'multiple-users'">
                    ¿Estás seguro que quieres 
                    {{data.action === 'delete' ? 'eliminar estos' : 
                      data.action === 'activate' ? 'activar estos' : 'desactivar estos'}} 
                    <span class="text-semibold">{{data.count}}</span> 
                    usuarios?
                </h5>
                
                <p class="text-warning mt-2" *ngIf="data.action === 'delete'">
                    Esta acción no se puede deshacer.
                </p>
                <p class="text-info mt-2" *ngIf="data.action !== 'delete'">
                    Los usuarios {{data.action === 'activate' ? 'activados' : 'desactivados'}} 
                    podrán {{data.action === 'activate' ? 'acceder' : 'perderán el acceso'}} al sistema.
                </p>
            </div>
        </div>
        <hr class="mt-5 mb-5">
        <div class="d-flex flex-row justify-center gap-20 mt-2">
            <button (click)="closeMdl();" class="btn btn-primary-outline text-center">Cancelar</button>
            <button class="btn btn-primary text-center" (click)="executeAction()" [disabled]="isLoading">
                {{isLoading ? 'Procesando...' : 
                 (data.action === 'delete' ? 'Eliminar' : 
                  data.action === 'activate' ? 'Activar' : 'Desactivar')}} 
                {{data.mode == 'multiple-users' ? 'usuarios' : 'usuario'}}
            </button>
        </div>
    </div>
</div>